export default "__VITE_ASSET__Cz2ikLn___"